var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:{
    active: _vm.active,
    disabled: _vm.disabled
  },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"icon",class:{active: _vm.active}},[_vm._t("default")],2),_c('span',[_vm._v(_vm._s(_vm.name))]),(_vm.disabled)?_c('span',{staticClass:"soon"},[_vm._v(_vm._s(_vm.$t("soon")))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }